export default {
	"delivery.ParameterError": "参数错误!",
	"delivery.ShipmentStatus": "发货状态",
	"delivery.Shipped": "已发货",
	"delivery.ShippingTime": "发货时间",
	"delivery.LogisticsTracking": "物流追踪",
	"delivery.ThereIsNoLogisticsInformation": "暂无物流信息",
	"delivery.ShippingAddress": "收货地址"
}